import React from 'react';
import { render } from 'react-dom';
import { createBrowserHistory } from 'history';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import './scss/theme.scss';
import reportWebVitals from './reportWebVitals';
import NotFoundScreen from './views/NotFoundScreen';
import ISADgCollection from './views/ISADgCollection/ISADgCollection';
import ISADgAgency from './views/ISADgAgency';
import ISADgItem from './views/ISADgItem';
import PrimaryScreen from './views/PrimaryScreen';
import GLIFOSService from './services/Api';
import ISADgCollection3 from './views/ISADgCollection3/ISADgCollection3';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-G8454T9E63');

const hist = createBrowserHistory();
const apiService = new GLIFOSService();
render(
	<BrowserRouter history={hist}>
		<Routes>
			<Route
				index
				path={process.env.PUBLIC_URL + '/'}
				element={<PrimaryScreen apiService={apiService} />}
			/>
			<Route
				index
				path={process.env.PUBLIC_URL + '/agency/:isadg'}
				element={<ISADgAgency apiService={apiService} />}
			/>
			{/* <Route
				index
				path={process.env.PUBLIC_URL + '/collection/:isadg'}
				element={<ISADgCollection apiService={apiService} />}
			/> */}
			<Route
				index
				path={process.env.PUBLIC_URL + '/collection/:isadg'}
				element={<ISADgCollection3 apiService={apiService} />}
			/>
			<Route
				index
				path={process.env.PUBLIC_URL + '/item/:isadg'}
				element={<ISADgItem apiService={apiService} />}
			/>
			<Route path='*' element={<NotFoundScreen />} />
		</Routes>
	</BrowserRouter>,
	document.getElementById('c-root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
